import { Component } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { MitigatingActionReview } from "../../_interfaces/MitigatingActionReview.model";
import { map, shareReplay, switchMap, take } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { RiskUser } from 'src/app/_interfaces/RiskUser.model';
import { MitigatingAction } from 'src/app/_interfaces/MitigatingAction.model';

@Component({
  selector: 'app-mitigation-review',
  templateUrl: './mitigation-review.component.html',
  styleUrls: ['./mitigation-review.component.css']
})
export class MitigationReviewComponent {

  //TODO: move into a service
  readonly apiRoutes = {
    getMitigationDetails: (mitigationId: number) => `MitigatingActions/${mitigationId}`,
    createReview: 'MitigatingActionReviews',
    updateReview: 'MitigatingActionReviews',
    getReviewDetails: (reviewId: number) => `MitigatingActionReviews/${reviewId}`
  };

  readonly navRoutes = {
    riskMitigation: (mitigationId: number) => `/myrisks/riskmitigations/${mitigationId}`
  };

  constructor(
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute) {
  }

  user$: Subject<RiskUser> = this.repository.user$;

  routeParams$: Observable<{ mitigationId: number; reviewId: number | null }> = this.activeRoute.params.pipe(
    shareReplay(1),
    map((params: Params) => ({mitigationId: +params['mitigationId'], reviewId: params['reviewId'] ? +params['reviewId'] : null}))
  );

  mitigationDetails$: Observable<MitigatingAction> = this.routeParams$.pipe(
    map((params) => params.mitigationId),
    switchMap((mitigationId: number) => this.getMitigationDetails$(mitigationId))
  );

  mitigationReview$: Observable<MitigatingActionReview> = this.routeParams$.pipe(
    switchMap((params) => {
      if (this.isExistingReview(params.reviewId)) {
        return this.getMitigationReview$(params.reviewId);
      }

      return this.initialiseNewReview$();
    })
  );

  //TODO: move into a service
  getMitigationDetails$(mitigationId: number): Observable<MitigatingAction> {
    return this.repository.getData(this.apiRoutes.getMitigationDetails(mitigationId)).pipe(
      take(1),
      map((response: MitigatingAction) => response)
    );
  }
  //TODO: move into a service
  getMitigationReview$(reviewId: number): Observable<MitigatingActionReview> {
    return this.repository.getData(this.apiRoutes.getReviewDetails(reviewId)).pipe(
      take(1),
      map((response: MitigatingActionReview) => response)
    );
  }

  initialiseNewReview$(): Observable<MitigatingActionReview> {
    return this.mitigationDetails$.pipe(
      switchMap((mitigation: MitigatingAction) => {
        const newReview: MitigatingActionReview = {
          title: 'Additional review after completing the previous review',
          actionsRequired: '',
          controlEffective: null,
          controlTested: false,
          decisionReason: '',
          description: 'Control review',
          effectiveReason: '',
          id: null,
          mitigatingActionId: mitigation.id,
          mitigationReviewDate: mitigation.reviewAndUpdateDate,
          notificationDate: null,
          reviewUpdateDate: mitigation.reviewAndUpdateDate,
          riskId: null,
          status: 1,
          updator: null
        };

        return of(newReview);
      })
    );
  }

  isExistingReview(reviewId: number | null): boolean {
    return reviewId !== null;
  }

  onFormSubmitted(updatedReview: MitigatingActionReview): void {
    this.routeParams$.pipe(take(1)).subscribe(params => {
      // Save updated Mitigating Action Review here
      if (this.isExistingReview(params.reviewId)) {
        this.repository.update(this.apiRoutes.updateReview, updatedReview)
          .subscribe(res => {
            this.router.navigate([this.navRoutes.riskMitigation(params.mitigationId)]);
            }, error => {
              alert('Error:!' + error.message + '\n\n');
            }
          );
      } else {
        this.repository.create(this.apiRoutes.createReview, updatedReview)
          .subscribe(res => {
            this.router.navigate([this.navRoutes.riskMitigation(params.mitigationId)]);
            }, error => {
              alert('Error:!' + error.message + '\n\n');
            }
          );
      }
    });

  }

  onFormCancelled(): void {
    this.routeParams$.pipe(take(1)).subscribe(params => {
      this.router.navigate([this.navRoutes.riskMitigation(params.mitigationId)]);
    });
  }
}
